exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-view.post-form-modal-view{align-items:flex-start\n}\n.post-form-modal-panel{flex-shrink:0;margin-top:25%;margin-bottom:2em;width:100%;max-width:700px\n}\n@media(orientation: landscape){\n.post-form-modal-panel{margin-top:8%\n}\n}", ""]);

// exports
